import { createApiRef } from '@backstage/core-plugin-api';
import { AdminToggleServiceApi } from '@runway/devkit-common';

export const adminToggleServiceApiRef = createApiRef<AdminToggleServiceApi>({
  id: 'runway.admin-toggle.service',
});
